import { render, staticRenderFns } from "./ComponentProject.vue?vue&type=template&id=9151532e&scoped=true&lang=html"
var script = {}
import style0 from "./ComponentProject.vue?vue&type=style&index=0&id=9151532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9151532e",
  null
  
)

export default component.exports